import { useDispatch } from "react-redux";
import { openWithEntry } from "src/store/slices/checkoutFlowSlice";

/**
 * Profile-dropdown CTA that opens the CheckoutFlowModal at the PlanPicker slide
 * (entry === 'pricing_nav'). Previously this called the legacy
 * `initiateSubscriptionPurchase` which dispatched `setPreparingCheckout(true)`
 * (the shimmer) and then `window.location.href`'d to `/subscription/checkout/:id`
 * — a route Group 10 task 10.5 is removing.
 *
 * For a Free user (the primary case visible today), `openWithEntry` mounts the
 * picker with the 2-card variant (Unlimited Documents + Lawyer-Backed, per Figma node
 * 243-3445).
 *
 * Follow-ups deferred to a separate change (captured in
 * memory:project_sidenav_upgrade_button):
 *   - 3-card `'all_plans'` picker variant per ss-10.png with `Current plan`
 *     marker on the user's current tier, for already-paying Tier I + Tier II
 *     users navigating to view plans.
 *   - Tier III (`inhouse_counsel`) should render a `Manage subscription` CTA
 *     instead, routing via `getPortalSession()` to the Chargebee portal.
 *   - Label + visibility cleanup: Free → "Subscribe to Inhouse"; Tier I + II →
 *     "Upgrade plan"; Tier III → hidden (manage CTA instead).
 */
const SubscribeCTA = ({ entryPoint, className, label }) => {
  const dispatch = useDispatch();
  // Shown for every plan, including $149 Counsel — the all-plans picker it opens
  // lets top-tier users see their current plan and downgrade/cancel options.

  const handleClick = () => {
    dispatch(openWithEntry({ entry: "pricing_nav" }));
  };

  return (
    <button
      data-testid="subscribe-cta"
      data-entry-point={entryPoint}
      type="button"
      onClick={handleClick}
      className={
        className ||
        "font-[400] text-[14px] font-sans text-[#686868] hover:font-[500] hover:text-[#0A0A0A] cursor-pointer text-left bg-transparent border-none p-0 w-full"
      }
    >
      {label || "Upgrade plan"}
    </button>
  );
};

export default SubscribeCTA;
